export default {
	config:{
		add:'إضافة',
		submit:'تسجيل',
		cancel:'الغاء',
		noData:'لاتوجد بيانات متاحة',
		delete:'مسح',
		refresh:'اعادة تحميل',
		back:'عودة',
		send:'ارسال',
		deleteMessage:'ستقوم بمسح الملف بشكل دائم في هذه العملية،هل تريد الاستمرار؟',
		warnTitle:'تحذير',
		success:'تم التسجيل بنجاح!',
		warnFill:'املأ من فضلك',
		warnNumber: 'برجاء إدخال قيم رقمية', 
		warnInvalid:'ملء غير صالح',
		start:'ابدأ',
		confirm:'تأكيد',
		goto:'برجاء الذهاب الى',
	},
	header:{
		changeLang:'اللغة',
		update:'تحديث',
		reset:'اعادة تعيين',
		logout:'تسجيل الخروج',
	},
	welcome:{
		title:' للجيل الخامسGreenPackt مرحبا في جهاز  ',
		button:'ابدأ',
		recommend:' موقع التثبيت الموصى به',
		recomText:'الإشارة قبل تركيب الجهاز للوصول لأفضل موقع للتركيب',
		next:'التالي',
		parsing:' تحليل خطوات التثبيت ',
		step1:'الخطوةالاولى',
		step1Text:'أسفل جسم الطائرة ، قم بتأكيد البطاقة',
		step2:'الخطوة الثانية',
		step2Text:'غطاء معدني ، برغي في فتحة البطاقة',
		step3:'الخطوة الثالثة',
		step3Text:'شد الغطاء ، مقاوم للماء والغبار',
		step4:'الخطوة الرابعة',
		step4Text:'إدخال كابل الشبكة ، حلقة الختم',
		step5:'الخطوة الخامسة',
		step5Text:'شد الطويق ، مقاوم للماء وآمن',
		step6:'الخطوة السادسة',
		step6Text:'الجزء الخلفي من جسم الطائرة ، أدخل مشبك الخرطوم',
		step7:'الخطوة السابعة',
		step7Text:'اربط المشبك في عمود التثبيت ، وشدّه وإصلاحه',
		step8:'الخطوة الثامنة',
		step8Text:'اضبط الزاوية وأكمل التثبيت',
		find:'قم بتعديل وضع واتجاه الجهاز للوصول لافضل اشارة.',
		nowSignal:'جودة الاشارة الحاليه',
		score:'نقاط',
		suggest:'إشارة ممتازة. استخدم هذا الموقع والوضع.',
		continue:'استمر بالتجربة',
		signalStrength:'قوة الاشارة',
		distributed:' توزيع سجل الكشف ',
		guide:'دليل الانترنت',
		guideSsid:'اسم شبكة اللاسلكي',
		guidePsw:'كلمة مرور الشبكة اللاسلكية',
		samePsw:'قم بضبط كلمة مرور الجهاز',
		sameText:'مثل كلمة مرور الشبكة اللاسلكية',
		oldPsw:'كلمة المرور القديمة',
		newPsw:'كلمة المرور الجديدة',
		passwordRuleText:'قواعد كلمة المرور: تتكون من 8الى 20 خانة، ويجب أن تحتوي على أرقام، وحروف كبيرة و حروف صغيرة، و أشكال خاصة',
		rules:{
			pwdMust:'كلمة المرور يجب',
			pwdRule:'كلمة المرور لاتوافق القواعد',
		},
		finish:'نهاية',
		resetWait:'برجاء الانتظار، جار اعادة التشغيل',
		newWlanName:'اسم الشبكة اللاسلكية الجديدة هو:',
		reloadPage:'يمكنك تغيير اعدادات الجهاز عن طريق زيارة صفحة الجهاز مرة ثانية',
	},
	login:{
		userName:'اسم المستخدم',
		userPassword:'كلمة مرور المستخدم',
		loginBtn:'تسجيل دخول',
		forgetPsw:'نسيت كلمة المرور',
		resetText:'لاستعادة ضبط المصنع، برجاء الضغط مع الاستمرار على زر استعادة الضبط (يمكن أن يؤدي لفقدان بيانات المستخدم الحالية)،واستعادة ضبط كلمة المرور. ',
	},
	menu:{
		home:'الرئيسية',
		mobilenet:'شبكة الجوال',
		easy:'الاعدادات الاساسية للشبكة اللاسلكية',
		terminal:'الاجهزة',
		tools:'الأدوات',
		sms:'الرسائل النصية',
		settings:'اعدادات متقدمة',
		advanced:{
			DeviceInformation:'بيانات الجهاز',
			NetworkMenu:{
				Network:'الشبكة',
				APNManagement:' إدارة APN ',
				DHCPSettings:'اعدادات DHCP',
				LTEConfiguration:'اعدادات الجيل الرابع',
				CellSelection:'اختيار الخلية',
				LockBand:'قفل النطاق',
				NetworkSelection:'اختيار الشبكة',
				CommandShell:'Command Shell',
			},
			WiFiMenu:{
				WiFi:'الشيكة اللاسلكية',
				WLANStatus:'وضع الشبكة اللاسلكية الداخلية',
				WLANSettings:'اعدادات الشبكة اللاسلكية الداخلية',
				WPS:'WPS',
				MACFILTER:'MAC مرشح',
			},
			FirewallMenu:{
				Firewall:'جدار الحماية',
				FirewallSettings:'اعدادات جدار الحماية',
				ALG:'ALG',
				PortForwarding:'اعادة توجية المنفذ',
				DMZsettings:'اعدادات DMZ',
				UPnP:'UPnP',
				IPFiltering:'مرشح عنوان IP',
				URLFiltering:' مرشح عنوان URL ',
				PortFiltering:'مرشح المنفذ',
			},
			SystemMenu:{
				System:'النظام',
				Maintenance:'الصيانة',
				DDNS:'DDNS',
				General:'نظرة عامة',
				Ping:'Ping',
				Update:'التحديث',
				TR069:'TR069',
				Iperf:'Iperf',
			},
			VoiceMenu:{
				VoiceSettings:'Voice Settings',
				SIPSever:'SIP Server',
				DigitalMap:'Digital Map',
			}
		},
	},
	home:{
		netStatusYes:'تم الاتصال بالشبكة',
		netStatusNo:'الشبكة غير متصلة',
		myDevice:'جهازي',
		devices:'الأجهزة المتصلة',
		moreInternet:'مزيد من إعدادات الشبكة',
		moreInfo:'بيانات جهازي',
		moreDevices:'إدارة الجهاز',
	},
	mobileNetwork:{
		pageConnect:'اتصال الانترنت',
		pageConnectInfo:{
			text:' اسم نقطة الوصول هو اسم بيانات الاعدادات المقروءة بواسطة جهازك، والذي يستخدم لاعداد اتصال بإدارة الشبكة بين الجهاز و شبكة الجوال. في أغلب الأحوال، يكون جهازك تلك الاعدادات في ملف نظام، ويمكن ملء بيانات نقطة الاتصال آليا.',
			apnName:'اسم نقطة الوصول',
			classId:'Class ID',
			IpType:'نوع عنوان IP',
			auth:'المصادقة',
			username:'اسم المستخدم',
			password:'كلمة المرور',
			up32:'أقصى عدد هو 32 شكل',
			up64:'أقصى عدد هو 64 شكل',
			MaxLimit:'الحد الأقصى: 16',
			None:'بدون',
		},
		pageSearch:'البحث عن شبكة الجوال',
		pageSearchInfo:{
			text:'يدعم الجهاز "الجيل الخامس من الانترنت الذكي" مما يمكن من اختيار الشبكة الأفضل آليا، كما تقدم تجربة انترنت أفضل',
			NetworkingMode:'وضع الشبكة',
			InternetSearchMethod:'طريقة بحث الانترنت',
		},
		search:'آلي',
	},
	myDevicesInfo:{
		SystemInfomation:'بيانات النظام',
		VersionInfomation:'بيانات الإصدار',
		LANStatus:' حالة الشبكة الداخلية LAN ',
		RunningTime:'مدة التشغيل',
		ProductModel:'موديل المنتج',
		HardwareVersion:'اصدار الجهاز',
		SoftwareVersion:'إصدار البرنامج',
		SerialNumber:'الرقم التسلسلي',
		MACAddress:' عنوان MAC ',
		WanIP:'عنوان IP لشبكة WAN',
		IPAddress:' عنوان IP ',
		SubnetMask:'Subnet Mask',
	},
	devicesManage:{
		title:'ادارة الجهاز',
		text:'عرض وادارة كل بيانات الجهاز',
		WiFiStatus:'وضع الشبكة اللاسلكية',
		Frequency:'تردد (قناة)',
		SecurityMode:'وضع التأمين',
		DeviceList:'قائمة الجهاز',
		onlineTable:'أجهزة متصلة',
		outlineTable:'أجهزة غير متصلة',
		allowNet:'السماح بالاتصال بالانترنت',
		stopTime:'وقت الانتهاء',
		editName:'تحرير اسم',
		deleteText:'هل أنت متأكد أنك تريد مسح الجهاز الحالي',
	},
	easyWlan:{
		title:'الإعداد السهل للشبكة اللاسكلية',
		text:'تعديل سريع لإسم الشبكة اللاسلكية وكلمة المرور',
		first5G:'المفضل 5G',
		first5GMessage:'عندما يتم عرض إشارة اللاسلكي لل 2.4G وال 5G معا، ستكون إشارة ال 5G هيا المفضلة لأنها تقدم سرعات أعلي في وجود نفس حالة قوة الإشارة. لضبط كل من ال 2.4G وال 5G بشكل منفصل، برجاء إلغاء خيار التبديل الذي يعرض كلا الإشارتين في نفس الوقت',
		SSID:'اسم الشبكة اللاسلكية',
		SecurityPolicy:'نهج التأمين',
		SecurityMode:'وضع التأمين',
		WPAOption:' خيار WPA ',
		Passwordrules:{
			PasswordrulesText:'قواعد كلمة المرور',
			UserNamerulesText:'قواعد اسم المستخدم',
			rules1:' طول الجملة في وضع WEP يكون بين 5 إلى 13 خانة.',
			rules2:'في الأوضاع الأخري، يكون الحد الأقصي للجملة بين 8 إلي 32 بت',
			rules3:'برجاء إدخال كلمة مرور بطول يتراوح بين 5 إلى 13 رقم.',
			rules4:'برجاء إدخال كلمة مرور بطول من 8-32.',
			rules5:'مسموح فقط باستخدام الأحرف الخاصة من A-Z و a-z و0-9',
			rules6:'طول السلسلة محدد بـ 1-32 رقم.',
			warnMessage:'تغيير الإعداد سوف يؤدي لقطع اتصال الشبكة اللاسلكية مؤقتا وقد يؤدي لفقدان اتصالك. إذا حدث ذلك، قم بإعادة الاتصال بشبكة اللاسلكي و قم بإعادة تحميل الصفحة.',
			successMessage:'تم التكوين بنجاح، برجاء اعادة الاتصال باستخدام بيانات الشبكة اللاسلكية الجديدة.',
		}
	},
	sms:{
		inbox:'صندوق البريد',
		outbox:'صندوق الصادر',
		settings:'الإعدادات',
		newMessage:'رسالة جديدة',
		phoneNumber:'الرقم',
		content:'المحتويات',
		date:'التاريخ',
		time:'الوقت',
		Recipient:'المستقبل',
		RemainingWords:'الحروف المتبقية',
		sender:'الراسل',
		smsCenterNumber:'رقم مركز الرسائل النصية',
		warnLimit:'الطول تعدي الحد',
		warnFill:'يرجى الملء و التقديم',
		warnNumber:'برجاء كتابة رقم مركز الرسائل النصية',
	},
	dhcpSettings:{
		LANHostSettings:'اعدادات مضيف الشبكة الداخلية',
		LocalIPAddress:'عنوان IP محلي',
		SubnetMask:'Subnet Mask',
		LANDHCPSettings:'اعدادات DHCP للشبكة الداخلية',
		DHCPServer:'خادم DHCP',
		StartIP:'عنوان IP للبداية',
		EndIP:'عنوان IP للنهاية',
		LeaseTime:'مدة الحجز (ث)',
		StaticRouteSettings:'Static Route اعدادات',
		Index:'الفهرس',
		DestinationIP:'المطلوب IPعنوان ',
		RouteSubnetMask:'Route Subnet Mask',
		Gateway:'البوابة',
		warnIp1:'عنوان IP المحلي غير صحيح',
		warnSubnetMask:' غير صحيحSubnet Mask  ',
		warnStartIp:'برجاء إدخال رقم صحيح أكبر من 0 وأقل من أو يساوي 255',
		warnEndIp:'عنوان IP النهاية يجب أن يكون أكبر من أو يساوي عنوان IP البداية',
		warnTime:' يرجى ملء القيمة المؤهلة ',
	},
	CellSelection:{
		Priority:'الأولوية',
		NetworkMode:'وضع الشبكة',
	},
	LockBand:{
		TechnologyModeSetting:'اعدادات وضع التكنولوجيا',
	},
	CommandShell:{
		CommandRunningResults:'نتائج تشغيل الأمر',
		Command:'أمر',
		warnEmpty:'لايمكن أن يكون الأمر فارغا',
	},
	WLANStatus:{
		APInformation:'بيانات نقطة الوصول',
		SSID:'اسم الشبكة اللاسلكية',
		TxPower:'Tx Power',
		Mode:'الوضع',
		Channel:'القناة',
		ChannelBandwidth:'عرض النطاق الترددي للقناة',
		Rates:'معدلات',
		Security:'التأمين',
	},
	WLANSettings:{
		BasicSettings:'اعدادات أساسية',
		Name:'الإسم',
		WLAN:'الشبكة اللاسلكية الداخلية',
		SSID:'اسم الشبكة اللاسلكية',
		CountryCode:'رمز البلد',
		Mode:'الوضع',
		ChannelBandwidth:'عرض النطاق الترددي للقناة',
		ChannelMode:'وضع القناة',
		Channel:'القناة',
		TxPower:'Tx Power',
		MaxSTAs:'Max STAs',
		MaxLength:'الحد الأقصى للطول',
	},
	WLANWps:{
		settings:'الاعدادات',
		WPSMode:'وضع WPS',
	},
	MacFilter:{
		nodeTitle:'مرشح MAC',
		MACFilterMode:'وضع مرشح MAC',
		WLANAccessList:'قائمة الوصول للشبكة اللاسلكية الداخلية',
		warnEmpty:'لايمكن أن يكون عنوان MAC فارغا',
		warnAddress:'عنوان MAC لايتناسب مع المعايير',
		whitelist:'القائمة البيضاء',
		blacklist:'القائمة السوداء',
	},
	FirewallSettings:{
		FirewallProtection:'جدار الحماية',
		SPIFirewall:' جدار حماية SPI ',
		BlockWANRequests:'حظر طلبات شبكة الانترنت',
		BlockAnonymousInternetRequests:'حظر طلبات الانترنت المجهولة',
		FilterIDENT:'Filter IDENT(Port 113)',
	},
	Alg:{
		IPSecPassthrough:'IPSec Passthrough',
		L2TPPassthrough:'L2TP Passthrough',
		PPTPPassthrough:'PPTP Passthrough',
		FTPPassthrough:'FTP Passthrough',
		H323Passthrough:'H323 Passthrough',
		SIPPassthrough:'SIP Passthrough',
		RTSPPassthrough:'RTSP Passthrough',
	},
	PortForwarding:{
		PortForwardingList:'قائمة منفذ التوجيه',
		Application:'التطبيق',
		PortFrom:'منفذ من',
		Protocol:'بروتوكول',
		IPAddress:'عنوان IP',
		PortTo:'منفذ إلى',
		Enable:'تفعيل',
		Disable:'إلغاء تفعيل',
		Both:'الكل',
	},
	Dmz:{
		DMZEnableStatus:'حالة تفعيل DMZ',
		DMZHostIPAddress:'عنوان IP لمضيف DMZ',
		ExcludeWebServerPort:' استبعاد منفذ خادم الويب ',
		ExcludeTelnetSSHPort:'استبعاد منفذ Telnet/SSH',
		ExcludePingService:'استبعاد خدمة PING',
	},
	Upnp:{
		UPnPConfiguration:'تكوين UPnP',
		UPnPService:'خدمة UPnP',
		UPnPNotificationInterval:'الفاصل الزمني لإعلام UPnP',
		DeleteAll:'مسح الكل',
	},
	IPFiltering:{
		IPFilter:'مرشح عنوان IP',
		EnableIPFilter:'تفعيل مرشح عنوان IP',
		message:' وظيفة مرشح عنوان IP في الشبكة اللاسلكية الداخلية يمكن أن تستخدم لتقييد وصول المستخدم لبعض خدمات الانترنت المحددة.',
		warnIp:'عنوان IP غير صحيح',
		maxLimit10:'الحد الأقصى: 10',
		empty:'لايمكن أن يكون عنوان IP فارغا',
		standard:'عنوان IP لايتوافق مع المعايير',
	},
	URLFiltering:{
		URLFilter:'مرشح عنوان URL',
		EnableURLFilter:'تفعيل عنوان URL',
		message:' وظيفة مرشح عنوان URL في الشبكة اللاسلكية الداخلية يمكن أن تستخدم لتقييد وصول المستخدم لبعض خدمات الانترنت المحددة.',
		maxLimit10:'الحد الأقصى:10',
	},
	PortFiltering:{
		PortFilter:'مرشح المنفذ',
		EnablePortFilter:'تفعيل مرشح المنفذ',
		message:' وظيفة مرشح المنفذ في الشبكة اللاسلكية الداخلية أن تقوم بتقييد وصول المستخدم لخدمات انترنت محددة.',
		maxLimit10:'الحد الأقصى:10',
		PortStart:'منفذ البداية',
		PortEnd:'منفذ النهاية',
	},
	Maintenance:{
		Reboot:'اعادة تشغيل',
		RebootText:'اضغط اعادة تشغيل لإعادة تشغيل الجهاز',
		FactoryReset:'استعادة ضبط المصنع',
		FactoryResetText:'اضغط زر استعادة ضبط المصنع لاستعادة اعدادات ضبط المصنع للجهاز',
		FactoryResetWarn:'اضغط استعادة ضبط المصنع لاستعادة الضبط',
		Syslog:'سجل النظام',
		Download:'تنزيل',
		Backup:'نسخ احتياطي لملف التكوين',
		BackupText:'للقيام بنسخ احتياطي لملف التكوين الحالي، اضغط على تنزيل',
		Restore:'استعادة ملف التكوين',
		RestoreText:'لاستعادة ملف التكوين، قم بتحديد مسار ملف التكوين المحلي، ثم قم باستيراد الملف واضغط على تحميل لاستعادة ملف التكويت',
		Upload:'تحميل',
	},
	DDNS:{
		DDNSService:' خدمة DDNS ',
		UserName:'اسم المستخدم',
		Password:'كلمة المرور',
		HostName:'اسم المضيف',
		Status:'الحالة',
		InternetIPAddress:'عنوان IP للانترنت',
	},
	General:{
		ChangePassword:'تغيير كلمة المرور',
		OldPassword:'كلمة مرور قديمة',
		NewPassword:'كلمة مرور جديدة',
		Passwordrules:'قواعدة كلمة المرور: يجب أن تكون من 8 ل 20 خانة و تحتوي على حروف كبيرة و صغيرة و أرقام و أشكال خاصة',
		ReentertoConfirm:'أعد الإدخال للتأكيد',
		TimeSettings:'اعدادات الوقت',
		NTPEnableStatus:'وضع تفعيل NTP',
		TimeZone:'النطاق الزمني',
		SummerTimeEnable:'تفعيل الوقت الصيفي',
		NTPServer:'خادم NTP',
		UseLocalHostTime:'استخدم وقت المضيف المحلي',
		RefreshInterval:'الفاصل الزمني للتحديث',
		minutes:'دقائق',
		AutoRefresh:'تحديث تلقائي',
		rePasswordMust:'كلمة المرور الجديدة مرة أخرى',
		passwordSame:'كلمتا المرور غير متماثلتان',
	},
	Ping:{
		PingTest:'اختبار Ping',
		IPProtocol:'بروتوكول عنوان IP',
	},
	Update:{
		LocalFirmwareUpdate:'تحديث محلي لبرنامج الجهاز',
		LocationText:'الموقع',
		ChooseFile:'اختر ملف',
	},
	systemTr:{
		ACSURL:' عنوان URL ل ACS ',
		ACSUserName:' اسم مستخدم ACS ',
		ACSUserPassword:' كلمة مرور ACS ',
		PeriodicInform:'إعلام دوري',
		PeriodicInformInterval:'مدة الإعلام الدوري',
		PeriodicInformTime:'وقت الإعلام الدوري',
		RequestUserName:'طلب اسم المستخدم',
		RequestUserPassword:'طلب كلمة المرور',
	},
	Iperf:{
		IperfSettings:' اعدادات Iperf ',
		Status:'الحالة',
		ServerAddress:'عنوان الخادم',
		ServerPort:'منفذ الخادم',
		ManagementPort:'منفذ الادارة',
		MeasurementTime:'وقت القياس',
		Seconds:'ثوان',
		ProtocolType:'نوع البروتوكول',
		WindowSize:'الوقت المتاح',
		TCPClientNumber:'رقم عميل TCP',
		DataLength:'طول البيانات',
		UDPBandwidth:'عرض النطاق الترددي UDP',
		UplinkSpeed:'سرعة خط التحميل',
		DownlinkSpeed:'سرعة خط التنزيل',
		UplinkLatency:'فترة كمون اخط التحميل',
		DownlinkLatency:'فترة كمون خط التنزيل',
	},
	VoiceSettings:{
		RegisterStatus:'VoIP Register Status',
		AuthorizationSatus:'Authorization Satus',
		RegServer:'Reg Server',
		Address:'Address',
		Port:'Port',
		SIPDomain:'SIP Domain',
		Domain:'Domain',
		SIPProxy:'SIP Proxy',
		Enable:'Enable',
		Authorization:'Authorization',
		AuthName:'Auth Name',
		PhoneName:'Phone Name',
		RegAccount:'Reg Account',
		RegPassword:'Reg Password',
	},
	DialtalMap:{
		DialPlan:'Dial Plan',
	}
}
